import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useCardBackgroundHeaderBlockStyles = makeStyles({
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: tokens.spacingHorizontalSNudge,
    ...shorthands.padding(
      tokens.spacingVerticalXXXL,
      tokens.spacingHorizontalNone,
      tokens.spacingVerticalNone,
      tokens.spacingHorizontalS,
    ),
  },
  title: {
    fontSize: tokens.fontSizeBase600,
    lineHeight: tokens.fontSizeHero800,
    fontWeight: tokens.fontWeightBold,
  },
  caption: {
    fontSize: tokens.fontSizeBase300,
    lineHeight: tokens.lineHeightBase300,
  },
});
